var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('base-price-row',{class:_vm.regularPriceClasses,attrs:{"label":"ゲスト","price-with-tax":_vm.priceWithTax}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }